import type { IUser, IRole } from "@/modules/auth/types";
import type { DealerFilterKey, DealerFilterPermissionsConfig } from "./types";

export function canViewDealerFilter(
    filterKey: DealerFilterKey,
    user: IUser | null,
    permissionsMap: DealerFilterPermissionsConfig | null,
): boolean {
    if (!user || !permissionsMap) {
        return false;
    }

    const permissionName = permissionsMap?.[filterKey];
    if (!permissionName) {
        return true;
    }

    return user.roles?.some((role: IRole) => role.permissions?.some((p) => p.name === permissionName)) ?? false;
}

export function getVisibleDealerFilters(user: IUser | null, permissionsMap: DealerFilterPermissionsConfig | null): DealerFilterKey[] {
    const allFilters: DealerFilterKey[] = ["oem", "state", "group", "program"];
    return allFilters.filter((filterKey) => canViewDealerFilter(filterKey, user, permissionsMap));
}
